import { createFileRoute } from "@tanstack/react-router";
import {
  MerchantLoginPage,
  parseMerchantLoginSearch,
} from "@/components/auth/MerchantLoginPage";
import { redirectIfAuthenticatedClient } from "@/lib/services/auth-guard";

export const Route = createFileRoute("/acceso/comercio")({
  validateSearch: parseMerchantLoginSearch,
  beforeLoad: async () => {
    await redirectIfAuthenticatedClient();
  },
  component: AccesoComercioPage,
  head: () => ({
    meta: [
      { title: "Acceso comercios — Structura Market" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

function AccesoComercioPage() {
  const search = Route.useSearch();
  return <MerchantLoginPage returnTo={search.returnTo} error={search.error} />;
}
